import get from 'lodash/get';

import { IReduxUser } from '../modules/core/types';

const DEFAULT_SHARE_USER_ID = 'usrshare';
export const SHARE_USER_ID = get(process.env, 'REACT_APP_SHARE_USER_ID') || DEFAULT_SHARE_USER_ID;

export const createUnknownUser = (id: string = '', nickName: string) => ({
  id,
  email: '',
  nickName,
});

export const createAnonymousUser = (userId: string = SHARE_USER_ID): IReduxUser => ({
  id: userId,
  nickName: '',
  color: '',
  image: ``,
});

export const isAnonymousUser = (userId: string) => userId === SHARE_USER_ID;
